import styled, { createGlobalStyle } from 'styled-components';
//import React from 'react';


const tlRodWidth = 6;

const tlThumbOuterDia = window.isTablet ? 16 : 12;
const tlThumbInnerDia = window.isTablet ? 12 : 8;


const tlColor = 'rgb(3, 144, 125)';
const tlBorderColor = 'rgb(240, 240, 240)';

const tlThumbBackgroundColor = 'rgb(255, 255, 255, 0.1)';
const tlThumbColor = 'rgb(3, 144, 125)';



const tlAltColor = 'rgb(233, 79, 53)';
const tlAltBorderColor = 'rgb(240, 240, 240)';

const tlAltThumbBackgroundColor = 'rgb(255, 255, 255, 0.1)';
const tlAltThumbColor = 'rgb(233, 79, 53)';


/*
const GlobalStyle = createGlobalStyle`
  :root {
    --tl-color: ${tlColor};
    --tl-border-color: ${tlBorderColor};
    --tl-thumb-color: ${tlThumbColor};
    --tl-thumb-background-color: ${tlThumbBackgroundColor};
    
    --tl-alt-color: ${tlAltColor};
    --tl-alt-border-color: ${tlAltBorderColor};
    --tl-alt-thumb-color: ${tlAltThumbColor};
    --tl-alt-thumb-background-color: ${tlAltThumbBackgroundColor};
  }
`;
*/

const TimelineConstants = {
    Color:tlColor,
    BorderColor:tlBorderColor,

    RodWidth:tlRodWidth,

    ThumbOuterDia:tlThumbOuterDia,
    ThumbInnerDia:tlThumbInnerDia,

    ThumbBackgroundColor:tlThumbBackgroundColor,
    ThumbColor:tlThumbColor,

    AltColor:tlAltColor,
    AltBorderColor:tlAltBorderColor,
    AltThumbBackgroundColor:tlAltThumbBackgroundColor,
    AltThumbColor:tlAltThumbColor,
};


const TimelineContainer = styled.div`
    position:relative;
    height:100%;
    width:100%;
`;


const TimelineRod = styled.div`
    position:absolute;
    height:${tlRodWidth}px;
    //background-color:${tlColor};
    //border:1px solid ${tlBorderColor};
    //border-radius:${tlRodWidth/2}px;
    //box-shadow: 2px 2px 6px 1px rgba(0,0,0,0.2);
`;


const AltTimelineRod = styled(TimelineRod)`
    //background-color:${tlAltColor};
    //border:1px solid ${tlAltBorderColor};
`;


const TimelineThumbOuter = styled.div`
  position: absolute;
  height: ${tlThumbOuterDia}px;
  width: ${tlThumbOuterDia}px;
  background-color: ${tlThumbBackgroundColor};
  border: 1px solid ${tlThumbColor};
  border-radius: ${tlThumbOuterDia/2}px;
  cursor: pointer;
  box-shadow: 1px 1px 6px 1px rgba(0,0,0,0.2);
`;


const AltTimelineThumbOuter = styled(TimelineThumbOuter)`
  background-color: ${tlAltThumbBackgroundColor};
  border: 1px solid ${tlAltThumbColor};
`;


const TimelineThumbInner = styled.div`
  position: absolute;
  height: ${tlThumbInnerDia}px;
  width: ${tlThumbInnerDia}px;
  background-color: ${tlThumbColor};
  border-radius: ${tlThumbInnerDia/2}px;
  pointer-events: none;
`;


const AltTimelineThumbInner = styled(TimelineThumbInner)`
  background-color: ${tlAltThumbColor};
`;



export {
    TimelineContainer,

    TimelineRod,
    TimelineThumbOuter,
    TimelineThumbInner,

    AltTimelineRod,
    AltTimelineThumbInner,
    AltTimelineThumbOuter,

    TimelineConstants,
};